export default __webpack_public_path__ + "static/media/3dArt.3487f826.png";